import { isEmail, isMobile } from "../../utilities/misc";
import * as actionTypes from "../actionTypes";

export type orderTypeStrict = {
  time_start: string;
  cleaner_id: number;
  client_firstname: string;
  client_lastname: string;
  client_mobile: string;
  client_address: string;
  latitude: number;
  longitude: number;
  client_email: string;
  info: string;
  full_payment: boolean;
  coupon_code: string;
  random_cleaner: boolean;
};

export type orderInfo = {
  orderId: number;
  time_start: string;
  cleaner_id: number | null;
  clientSecret: string | undefined;
  random_cleaner: boolean;
  status: actionTypes.order["order"]["status"];
} | null;

export type orderType =
  | { [key in keyof orderTypeStrict]: orderTypeStrict[key] | null }
  | orderTypeStrict;

export const initialState: {
  details: orderType;
  orderInfo: orderInfo;
  success: boolean;
  direct: boolean;
} = {
  details: {
    time_start: null,
    cleaner_id: null,
    client_firstname: null,
    client_lastname: null,
    client_mobile: null,
    client_address: null,
    latitude: null,
    longitude: null,
    client_email: null,
    info: ``,
    full_payment: false,
    coupon_code: null,
    random_cleaner: true
  },
  orderInfo: null,
  success: false,
  direct: false
};

export type proceed_val_type = (typeof section_array)[number];
export const section_array: [0, 1, 2, 3] = [0, 1, 2, 3];
export const disableSection = (
  num: proceed_val_type,
  onlyGift: boolean
): boolean => {
  if (onlyGift && num === 1) {
    return true;
  } else {
    return false;
  }
};
export const isComplete = (
  level: proceed_val_type,
  details: orderType,
  ignoreOrderDetails: boolean,
  gift_only: boolean
): boolean => {
  if (ignoreOrderDetails) {
    return true;
  } else {
    const stage1 = true;
    const stage2 = gift_only
      ? true
      : details.client_address &&
        details.latitude &&
        details.longitude &&
        (details.cleaner_id || details.random_cleaner) &&
        details.time_start
      ? true
      : false;
    const stage3 =
      details.client_lastname?.trim() &&
      details.client_firstname?.trim() &&
      details.client_email &&
      isEmail(details.client_email) &&
      details.client_mobile &&
      isMobile(details.client_mobile)
        ? true
        : false;
    const stage4 = details ? true : false;
    switch (level) {
      case 0:
        return stage1;
      case 1:
        return stage1 && stage2;
      case 2:
        return stage1 && stage2 && stage3;
      case 3:
        return stage1 && stage2 && stage3 && stage4;
      default:
        return false;
    }
  }
};

const reducer = (
  state = initialState,
  action: { type: string; payload: orderType }
): typeof initialState => {
  switch (action.type) {
    case actionTypes.SET_ORDER_DETAILS: {
      return {
        ...state,
        details: { ...action.payload }
      };
    }
    case actionTypes.CLEAR_ORDER_DETAILS: {
      return {
        ...state,
        details: { ...initialState.details }
      };
    }
    case actionTypes.SET_ORDER_INFO: {
      return {
        ...state,
        orderInfo: action.payload as unknown as orderInfo
      };
    }
    case actionTypes.SET_PAYMENT_SUCCESS: {
      return {
        ...state,
        success: action.payload as unknown as boolean
      };
    }
    case actionTypes.DIRECT_PAYMENT: {
      return {
        ...state,
        direct: action.payload as unknown as boolean
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
